import noUiSlider from 'nouislider';

/* Beispiel-Html:

	<div class="element--range-slider" id="{$id}" data-min="{$min}" data-max="{$max}"></div>
	<input type="number" id="{$id}-from" />
	<input type="number" id="{$id}-to" />
*/
export default function (element) {
	const id = element.getAttribute('id');
	const inputFrom = document.getElementById(id+'-from');
	const inputTo = document.getElementById(id+'-to');

	const range = {
		'min': element.getAttribute('data-min') ? parseInt(element.getAttribute('data-min')) : 0,
		'max': element.getAttribute('data-max') ? parseInt(element.getAttribute('data-max')) : 100
	};

	noUiSlider.create(element, {
		range: range,
		step: 1,
		start: [range.min, range.max],
		connect: true,
	});

	element.noUiSlider.on('change', handleSliderChange);
	element.noUiSlider.on('update', handleSliderChange);

	$(inputFrom).on('change', handleInputChange);
	$(inputTo).on('change', handleInputChange);

	function handleSliderChange(e) {
		inputFrom.value = Math.floor(e[0]);
		inputTo.value = Math.floor(e[1]);
	}

	function handleInputChange(e) {
		if(e.target.id === inputFrom.id) {
			element.noUiSlider.set([inputFrom.value, null])
		} else {
			element.noUiSlider.set([null, inputTo.value])
		}
	}
}